@import '~less/global-variables';

.mapboxgl-ctrl-bottom-left {
  left: 45%;

  .mapboxgl-ctrl-scale {
    border: 1px solid @gray;
    border-bottom: 0;
    border-top: 0;
    color: @gray;
  }
}
